/* eslint-disable react/destructuring-assignment */
import * as React from 'react';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import CardActionArea from '@mui/material/CardActionArea';
import configs from '../config';
// import readImage from '../static/images/readNotification.png';
// import unreadImage from '../static/images/unreadNotification.jpg';

export default function RecipeReviewCard(props) {
  const [IsRead, setIsRead] = React.useState(props.isRead);

  const handleExpandClick = (notificationId) => {
    // make notification as read here
    // console.log({ IsRead, notificationId });
    setIsRead(true);
    configs.BaseAxios.put(
      'status-read',
      { notification_id: notificationId },
      {
        headers: {
          'x-btz-token': props.btztoken,
        },
      }
    );
    // eslint-disable-next-line no-console
    console.log(props.btztoken);
  };

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div>
      <Card
        // sx={{ minWidth: 375 }}
        style={{
          backgroundColor: props.isGlobal ? '#13132C' : '#121212',
          margin: '0px',
          Width: '90%', // '343px',
          padding: '16px',
        }}
        onClick={() => handleExpandClick(props.notificationId)}
      >
        <CardActionArea>
          <CardHeader
            style={{
              color: '#FFFFFF',
              padding: '0px',
              display: 'flex',
              flexDirection: 'row-reverse',
            }}
            titleTypographyProps={{
              fontFamily: 'FF Mark Pro',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '700',
              lineHeight: '24px',
            }}
            title={<span>{props.notificationTitle}</span>}
            // subheader="20 Oct, 2022"
            avatar={
              IsRead ? (
                ''
              ) : (
                <div
                  style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '999px',
                    backgroundColor: '#F3B72B',
                  }}
                />
              )
            }
          />
          <CardContent
            style={{
              padding: '0px',
            }}
          >
            <Typography
              variant="body2"
              color="white"
              style={{
                padding: '8px 0px 0px 0px',
                fontFamily: 'FF Mark Pro',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: '400',
                lineHeight: '16px',
              }}
            >
              {props.notificationBody}
            </Typography>
          </CardContent>
        </CardActionArea>
        <CardActions
          disableSpacing
          style={{ padding: '0px' }}
          onClick={() => handleExpandClick(props.notificationId)}
        >
          <Typography
            paragraph
            style={{
              padding: '8px 0px 0px 0px',
              margin: '0px',
              color: 'white',
              fontFamily: 'FF Mark Pro',
              fontSize: '10px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '13px',
            }}
          >
            {props.notificationTime}
          </Typography>
        </CardActions>
      </Card>
    </div>
  );
}
